import { Card, CardContent, CardProps } from '@mui/material'

export const AuthCard = ({ children, sx, ...rest }: CardProps) => {
  return (
    <Card {...rest} sx={{ ...sx, p: 3, maxWidth: 550, width: '100%' }}>
      <CardContent>{children}</CardContent>
    </Card>
  )
}
